
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ie/scooter",
      function () {
        return require("private-next-pages/ie/scooter.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ie/scooter"])
      });
    }
  